import ajDentalLogo from "../Images/Client/LOGO/1. AJIDS.JPG";
import ajMedicalLogo from "../Images/Client/LOGO/2. AJIMS.JPG";
import akashHospitalLogo from "../Images/Client/LOGO/3. Akash_Hosp.JPG";
import arunodayaHospitalLogo from "../Images/Client/LOGO/4. Arunodaya_Hosp.JPG";
import bhsLakeviewLogo from "../Images/Client/LOGO/5. BHS_Lakeview.jpg";
import eastPointLogo from "../Images/Client/LOGO/6. EastPoint.jpg";
import everestHospitalLogo from "../Images/Client/LOGO/7. Everest.jpg";
import firstNeuroLogo from "../Images/Client/LOGO/8. First_Neuro.JPG";
import jssDentalMedicalLogo from "../Images/Client/LOGO/9. JSS Dental_Medical.jpg";
import jssChamarajnagarLogo from "../Images/Client/LOGO/10. JSS_Chamarajnagar.jpg";
import kempannaHospitalLogo from "../Images/Client/LOGO/11. Kempanna_Hospital.JPG";
import oxfordDentalLogo from "../Images/Client/LOGO/13. Oxford_Dental.jpg";
import oxfordMedicalLogo from "../Images/Client/LOGO/14. Oxford_Medical.jpg";
import sriNarayanaHospitalLogo from "../Images/Client/LOGO/15. Sri_Narayana_Hospital.jpg";
import suyogHospitalLogo from "../Images/Client/LOGO/16. Suyog_Hospital.jpg";
import spandanDiagnosticLogo from "../Images/Client/LOGO/Spandan_Diagnostic_Centre.png";

/** Remote logos for Kolkata/Patna clients and international deployments. */
const LOGO_BASE = "https://www.gestalttechindia.in/assets/img/team";

const karnatakaClients = [
  {
    id: "aj-dental-college",
    name: "A J Dental College",
    location: "Mangaluru",
    logo: ajDentalLogo,
  },
  {
    id: "aj-medical-college",
    name: "A J Medical College",
    location: "Mangaluru",
    logo: ajMedicalLogo,
  },
  {
    id: "akash-hospital",
    name: "Akash Hospital",
    location: "AIMS&RC",
    logo: akashHospitalLogo,
  },
  {
    id: "arunodaya-hospital",
    name: "Arunodaya Hospital",
    location: "Bellary",
    logo: arunodayaHospitalLogo,
  },
  {
    id: "bhs-lakeview",
    name: "BHS Lakeview Hospital",
    location: "Belagavi",
    logo: bhsLakeviewLogo,
  },
  {
    id: "eastpoint-medical",
    name: "Eastpoint Medical College & Hospital",
    location: "Bengaluru",
    logo: eastPointLogo,
  },
  {
    id: "everest-hospital",
    name: "Everest Hospital",
    location: "Bengaluru",
    logo: everestHospitalLogo,
  },
  {
    id: "first-neuro",
    name: "First Neuro Hospital",
    location: "Mangaluru",
    logo: firstNeuroLogo,
  },
  {
    id: "jss-dental-medical",
    name: "JSS Dental & Medical College",
    location: "Mysuru",
    logo: jssDentalMedicalLogo,
  },
  {
    id: "jss-chamarajnagar",
    name: "JSS Hospital",
    location: "Chamarajnagar",
    logo: jssChamarajnagarLogo,
  },
  {
    id: "kempanna-hospital",
    name: "Kempanna Hospital",
    location: "Hosakote, Bengaluru",
    logo: kempannaHospitalLogo,
  },
  {
    id: "oxford-dental",
    name: "The Oxford Dental College",
    location: "Bengaluru",
    logo: oxfordDentalLogo,
  },
  {
    id: "oxford-medical",
    name: "The Oxford Medical College",
    location: "Bengaluru",
    logo: oxfordMedicalLogo,
  },
  {
    id: "sri-narayana",
    name: "Sri Narayana Hospital",
    location: "Whitefield, Bengaluru",
    logo: sriNarayanaHospitalLogo,
  },
  {
    id: "suyog-hospital",
    name: "Suyog Hospital",
    location: "Bengaluru",
    logo: suyogHospitalLogo,
  },
];

const kolkataPatnaClients = [
  {
    id: "ruby-general",
    name: "Ruby General Hospital",
    location: "Kolkata",
    logo: `${LOGO_BASE}/RubyGeneralHospital.png`,
  },
  {
    id: "westbank-hospital",
    name: "WestBank Hospital",
    location: "Kolkata",
  },
  {
    id: "westbank-cancer",
    name: "Westbank Cancer Hospital",
    location: "Kolkata",
  },
  {
    id: "sanjiban",
    name: "Sanjiban Hospital",
    location: "Fuleswar",
    logo: `${LOGO_BASE}/sanjibanHospital.png`,
  },
  {
    id: "ruban-memorial",
    name: "Ruban Memorial Hospital",
    location: "Patna",
    logo: `${LOGO_BASE}/team-img19.jpg`,
  },
  {
    id: "ruban-women-child",
    name: "Ruban Women and Child Hospital",
    location: "Patna",
    logo: `${LOGO_BASE}/team-img20.jpg`,
  },
  {
    id: "udayan",
    name: "Udayan Hospital",
    location: "Patna",
    logo: `${LOGO_BASE}/team-img26.jpg`,
  },
  {
    id: "spandan-hospital",
    name: "Spandan Hospital",
    location: "Kolkata",
    logo: `${LOGO_BASE}/team-img22.jpg`,
  },
  {
    id: "spandan-diagnostic",
    name: "Spandan Diagnostic Centre",
    location: "Kolkata",
    logo: spandanDiagnosticLogo,
  },
  {
    id: "manorama-hospitex",
    name: "Manorama Hospitex",
    location: "Ranaghat",
    logo: `${LOGO_BASE}/team-img14.jpg`,
  },
  {
    id: "manorama-diagnostic",
    name: "Manorama Diagnostic Centre",
    location: "Kolkata",
    logo: `${LOGO_BASE}/MonoramaHospital.png`,
  },
  {
    id: "bmrc-hospital",
    name: "BMRC Hospital",
    location: "Kolkata",
    logo: `${LOGO_BASE}/team-img6.jpg`,
  },
  {
    id: "medella-cancer",
    name: "Medella Cancer Care",
    location: "Kolkata",
    logo: `${LOGO_BASE}/team-img15.jpg`,
  },
  {
    id: "mediview-hospital",
    name: "Mediview Hospital",
    location: "Kolkata",
    logo: `${LOGO_BASE}/team-img16.jpg`,
  },
  {
    id: "mother-hospital",
    name: "Mother Hospital",
    location: "Kolkata",
    logo: `${LOGO_BASE}/team-img17.jpg`,
  },
  {
    id: "greenview-hospital",
    name: "Greenview Hospital",
    location: "Kolkata",
    logo: `${LOGO_BASE}/team-img11.jpg`,
  },
  {
    id: "sunshine-hospital",
    name: "Sunshine Hospital",
    location: "Kolkata",
    logo: `${LOGO_BASE}/sunshineMulitspecialty.png`,
  },
  {
    id: "lotus-rajarhat",
    name: "Lotus Hospital",
    location: "Rajarhat, Kolkata",
  },
  {
    id: "lotus-madhyamgram",
    name: "Lotus Superspecialty Hospital",
    location: "Madhyamgram, Kolkata",
  },
];

const internationalClients = [
  {
    id: "as-salam-maadi",
    name: "As Salam International Hospital",
    location: "Maadi, Cairo, Egypt",
    logo: `${LOGO_BASE}/team-img27.jpg`,
  },
  {
    id: "as-salam-kattameya",
    name: "As Salam International Hospital",
    location: "Kattameya, Cairo, Egypt",
    logo: `${LOGO_BASE}/team-img28.jpg`,
  },
  {
    id: "dar-al-fouad-october",
    name: "Dar Al Fouad Hospital",
    location: "October City, Egypt",
    logo: `${LOGO_BASE}/team-img29.jpg`,
  },
  {
    id: "dar-al-fouad-nasr",
    name: "Dar Al Fouad Hospital",
    location: "Nasr City, Egypt",
    logo: `${LOGO_BASE}/team-img30.jpg`,
  },
  {
    id: "tabibi",
    name: "Tabibi Clinics",
    location: "Cairo, Egypt",
    logo: `${LOGO_BASE}/team-img31.jpg`,
  },
  {
    id: "sarhan",
    name: "Sarhan Obesity Clinic",
    location: "Cairo, Egypt",
    logo: `${LOGO_BASE}/team-img32.jpg`,
  },
  {
    id: "mediheal-eldoret-main",
    name: "Mediheal Hospital",
    location: "Eldoret Main, Kenya",
    logo: `${LOGO_BASE}/EldoretMain_Mediheal.png`,
  },
  {
    id: "mediheal-eldoret-town",
    name: "Mediheal Hospital",
    location: "Eldoret Town Clinic, Kenya",
    logo: `${LOGO_BASE}/EldoretTown_Mediheal.png`,
  },
  {
    id: "mediheal-nakuru-main",
    name: "Mediheal Hospital",
    location: "Nakuru Main, Kenya",
    logo: `${LOGO_BASE}/NakuruMain_Mediheal.png`,
  },
  {
    id: "mediheal-nakuru-town",
    name: "Mediheal Hospital",
    location: "Nakuru Town Clinic, Kenya",
    logo: `${LOGO_BASE}/Nakurutownclinic_Mediheal.png`,
  },
  {
    id: "mediheal-parklands",
    name: "Mediheal Hospital",
    location: "Parklands, Kenya",
    logo: `${LOGO_BASE}/Parklands_mediheal.png`,
  },
  {
    id: "mediheal-nairobi-eastleigh",
    name: "Mediheal Hospital",
    location: "Nairobi Eastleigh, Kenya",
    logo: `${LOGO_BASE}/NairobiEastleigh_Mediheal.png`,
  },
  {
    id: "mediheal-nairobi-upperhill",
    name: "Mediheal Hospital",
    location: "Nairobi Upper Hill, Kenya",
    logo: `${LOGO_BASE}/NairobiUpperhill_mediheal.png`,
  },
  {
    id: "mediheal-kigali",
    name: "Mediheal Hospital",
    location: "Kigali, Rwanda",
    logo: `${LOGO_BASE}/Kigali_Mediheal.png`,
  },
];

export const clientLogos = [
  ...karnatakaClients,
  ...kolkataPatnaClients,
  ...internationalClients,
];
